(function() {
  var initAttempts = 0;
  var maxInitAttempts = 60;

  function clearPricePending() {
    if (document.body) document.body.classList.remove('hulk-price-pending');
  }
  // Ждём загрузки всех компонентов
  var initInterval = setInterval(function() {
    initAttempts += 1;
    if (typeof hulkapps === 'undefined' || typeof hulk_variants === 'undefined' || typeof hulkapps_jQuery === 'undefined') {
      if (initAttempts >= maxInitAttempts) {
        clearInterval(initInterval);
        clearPricePending();
      }
      return;
    }
    clearInterval(initInterval);
    
    var $ = hulkapps_jQuery;
    var $priceEl = $('.t4s-product-price').first();
    var $moneySpan = $priceEl.find('.money');
    if (!$priceEl.length) {
      clearPricePending();
      return;
    }

    console.log('[Hulk Fix] Initialized');

    // Получаем цену варианта по ID
    function getVariantPrice(variantId) {
      var variant = hulk_variants.find(function(v) { return v.id == variantId; });
      return variant ? variant.price : null;
    }

    // Получаем текущий выбранный variant ID
    function getCurrentVariantId() {
      var select = document.querySelector('select[name="id"]');
      if (select) return parseInt(select.value);
      var input = document.querySelector('input[name="id"]');
      if (input) return parseInt(input.value);
      return null;
    }

    // Форматируем цену
    function formatMoney(cents) {
      if (window.T4SThemeSP && window.T4SThemeSP.Currency && typeof window.T4SThemeSP.Currency.formatMoney === 'function') {
        return window.T4SThemeSP.Currency.formatMoney(cents);
      }

      var dollars = (cents / 100).toFixed(2);
      var parts = dollars.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    function moneyTextToCents(text) {
      var normalized = String(text || '').replace(/\s/g, '').replace(/[^0-9.,-]/g, '');
      if (!normalized) return 0;

      var comma = normalized.lastIndexOf(',');
      var dot = normalized.lastIndexOf('.');
      var decimalSeparator = comma > dot ? ',' : '.';

      if (decimalSeparator === ',') {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = normalized.replace(/,/g, '');
      }

      return Math.round((parseFloat(normalized) || 0) * 100);
    }

    function setPriceHtml($target, html) {
      $target.html(html);
      if (document.body) document.body.dispatchEvent(new CustomEvent('currency:update', { bubbles: true }));
      if (window.jQuery_T4NT) window.jQuery_T4NT(document.body).trigger('currency:update');
    }


    // Получаем сумму всех выбранных Hulk опций
    function getHulkOptionsTotal() {
      var total = 0;
      
      // Swatch опции (radio style)
      var countedRadios = [];
      $('.hulk_po_radio.swatch_selected, .hulk_po_radio.button_selected').each(function() {
        if (countedRadios.indexOf(this) !== -1) return;
        countedRadios.push(this);
        var price = parseFloat($(this).attr('data-price')) || 0;
        total += price * 100;
      });
      
      // Radio button опции
      $('.hulk_po_radiobutton:checked').each(function() {
        var price = parseFloat($(this).attr('data-price')) || 0;
        total += price * 100;
      });
      
      // Checkbox опции
      $('.hulk_po_checkbox:checked').each(function() {
        var price = parseFloat($(this).attr('data-price')) || 0;
        total += price * 100;
      });
      
      // Select/dropdown опции
      $('select.hulkapps_option_child').each(function() {
        var selected = $(this).find('option:selected');
        var price = parseFloat(selected.attr('data-price')) || 0;
        total += price * 100;
      });

      // ===== WROUGHT IRON SIZE CALCULATOR =====
      var hEl = document.getElementById('wi-door-height');
      var wEl = document.getElementById('wi-door-width');
      if (hEl && wEl) {
        var h = parseFloat(hEl.value);
        var w = parseFloat(wEl.value);
        if (h > 0 && w > 0) {
          var variantId2 = getCurrentVariantId();
          var variantPrice2 = getVariantPrice(variantId2) || 0;
          var sizePriceCents = Math.round((h * w) / 144 * 180 * 100);
          total += sizePriceCents - variantPrice2;
        }
      }
      // =========================================

      return Math.round(total);
    }

    function syncHulkRadioLabel(label) {
      setTimeout(function() {
        var child = label.querySelector('.hulk_po_radio');
        if (!child) {
          updateTotalPrice();
          return;
        }

        var input = child.querySelector('input[type="radio"]');
        if (!input) {
          updateTotalPrice();
          return;
        }

        if (!input.checked) {
          var option = label.closest('.hulkapps_option');
          var selectedClass = child.getAttribute('data-val-selected-class') || (label.classList.contains('hulkapps_swatch_option') ? 'swatch_selected' : 'button_selected');

          if (option && input.name) {
            option.querySelectorAll('input[type="radio"][name="' + input.name + '"]').forEach(function(radio) {
              radio.checked = false;
              var radioChild = radio.closest('.hulk_po_radio');
              if (radioChild) radioChild.classList.remove('button_selected', 'swatch_selected', selectedClass);
            });
          }

          input.checked = true;
          child.classList.add(selectedClass);

          var hiddenClass = child.getAttribute('data-hidden-class');
          var hiddenInput = option && hiddenClass ? option.querySelector('.' + hiddenClass) : null;
          if (!hiddenInput && option) hiddenInput = option.querySelector('input[type="hidden"]');
          if (hiddenInput) hiddenInput.value = input.value;

          input.dispatchEvent(new Event('change', { bubbles: true }));
          child.dispatchEvent(new Event('change', { bubbles: true }));
        }

        setTimeout(updateTotalPrice, 50);
      }, 80);
    }

    // Главная функция обновления цены
    function cleanOptionText(text) {
      return (text || '')
        .replace(/\*/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getHulkOptionName(option) {
      var hidden = option.querySelector('input[type="hidden"][name^="properties["]');
      if (hidden) {
        var match = hidden.name.match(/^properties\[(.+)\]$/);
        if (match) return cleanOptionText(match[1]);
      }

      var title = option.querySelector('.hulkapps_option_name, .hulkapps_option_label, .hulkapps_option_title, .hulkapps_label');
      return title ? cleanOptionText(title.textContent) : '';
    }

    function getPricedHulkValue(source, fallbackValue) {
      if (!source) return cleanOptionText(fallbackValue);

      var value = cleanOptionText(
        fallbackValue ||
        source.value ||
        source.getAttribute('value') ||
        source.getAttribute('data-conditional-value') ||
        source.textContent
      );

      if (!value) return '';
      if (/\[\s*\$?[\d,]+(?:\.\d{2})?\s*\]/.test(value)) return value;

      var price = parseFloat(source.getAttribute('data-price')) || 0;
      if (!price && source.closest) {
        var pricedParent = source.closest('[data-price]');
        if (pricedParent) price = parseFloat(pricedParent.getAttribute('data-price')) || 0;
      }

      return price > 0 ? value + ' [ $' + price.toFixed(2) + ' ]' : value;
    }

    function addHulkProperty(properties, name, value) {
      name = cleanOptionText(name);
      value = cleanOptionText(value);
      if (!name || !value) return;
      properties[name] = value;
    }

    function collectHulkProperties() {
      var container = document.querySelector('.hulkapps_product_options');
      var properties = {};
      if (!container) return properties;

      container.querySelectorAll('input[type="hidden"][name^="properties["]').forEach(function(input) {
        var match = input.name.match(/^properties\[(.+)\]$/);
        if (match) addHulkProperty(properties, match[1], input.value);
      });

      container.querySelectorAll('.hulkapps_option').forEach(function(option) {
        if (option.classList.contains('information_render')) return;
        if (option.offsetParent === null || option.style.display === 'none') return;

        var name = getHulkOptionName(option);
        if (!name) return;

        var selectedButton = option.querySelector('.hulk_po_radio.button_selected, .hulk_po_radio.swatch_selected');
        if (selectedButton) {
          var selectedInput = selectedButton.querySelector('input[type="radio"]');
          addHulkProperty(properties, name, getPricedHulkValue(selectedInput || selectedButton));
          return;
        }

        var checkedRadio = option.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          addHulkProperty(properties, name, getPricedHulkValue(checkedRadio));
          return;
        }

        var checkboxValues = [];
        option.querySelectorAll('input[type="checkbox"]:checked').forEach(function(input) {
          var value = getPricedHulkValue(input);
          if (value && checkboxValues.indexOf(value) === -1) checkboxValues.push(value);
        });
        if (checkboxValues.length) {
          addHulkProperty(properties, name, checkboxValues.join(', '));
          return;
        }

        var select = option.querySelector('select.hulkapps_option_child, select');
        if (select && select.selectedIndex >= 0) {
          var selectedOption = select.options[select.selectedIndex];
          addHulkProperty(properties, name, getPricedHulkValue(selectedOption, selectedOption.text || selectedOption.value));
        }
      });

      return properties;
    }

    function findMainProductForm() {
      return document.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    }

    function syncHulkPropertiesToForm(form) {
      form = form || findMainProductForm();
      if (!form || !document.querySelector('.hulkapps_product_options')) return false;

      var properties = collectHulkProperties();
      var names = Object.keys(properties);

      form.querySelectorAll('[data-hulk-theme-property]').forEach(function(input) {
        input.remove();
      });

      names.forEach(function(name) {
        var inputName = 'properties[' + name + ']';
        var existing = Array.prototype.slice.call(form.querySelectorAll('[name]')).find(function(input) {
          return input.name === inputName;
        });

        if (existing) {
          existing.value = properties[name];
          return;
        }

        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = inputName;
        input.value = properties[name];
        input.setAttribute('data-hulk-theme-property', 'true');
        form.appendChild(input);
      });

      window.__hulkThemeLastProperties = properties;
      return names.length > 0;
    }

    var pendingStickyAtcButton = null;

    function getAtcAnimationClass(button) {
      if (!button) return '';
      try {
        var animation = JSON.parse(button.getAttribute('data-animation-atc') || '{}');
        return animation.ani || '';
      } catch (e) {
        return '';
      }
    }

    function clearAtcAnimation(button) {
      if (!button) return;
      var animationClass = getAtcAnimationClass(button);
      button.classList.remove('is--animated');
      if (animationClass) button.classList.remove(animationClass);
    }

    function playAtcAnimation(button) {
      if (!button) return;
      var animationClass = getAtcAnimationClass(button);
      if (!animationClass || animationClass === 'none') return;
      clearAtcAnimation(button);
      button.offsetWidth;
      button.classList.add('is--animated', animationClass);
    }

    function clickMainAddToCart() {
      var form = findMainProductForm();
      var submitButton = form && form.querySelector('.hulkapps_submit_cart, button[name="add"][data-atc-form], [data-atc-form], button[name="add"]');
      if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return false;
      submitButton.click();
      return true;
    }

    document.addEventListener('click', function(event) {
      var stickyButton = event.target.closest('.t4s-sticky-atc__atc[data-action-atc]');
      if (stickyButton && document.querySelector('.hulkapps_product_options')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        pendingStickyAtcButton = stickyButton;
        clearAtcAnimation(stickyButton);
        clickMainAddToCart();
        return false;
      }

      var addButton = event.target.closest('button[name="add"], [data-atc-form], .hulkapps_submit_cart, form[action*="/cart/add"] button[type="submit"]');
      if (addButton) {
        syncHulkPropertiesToForm(addButton.closest('form') || findMainProductForm());
      }
    }, true);

    document.addEventListener('submit', function(event) {
      if (event.target && event.target.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) {
        syncHulkPropertiesToForm(event.target);
      }
    }, true);

    function handleStickyAtcSuccess() {
      if (!pendingStickyAtcButton) return;
      playAtcAnimation(pendingStickyAtcButton);
      pendingStickyAtcButton = null;
    }

    function handleStickyAtcError() {
      if (!pendingStickyAtcButton) return;
      clearAtcAnimation(pendingStickyAtcButton);
      pendingStickyAtcButton = null;
    }

    document.addEventListener('cart:refresh', handleStickyAtcSuccess);
    document.addEventListener('cart:change', handleStickyAtcSuccess);
    document.addEventListener('cart:updated', function(event) {
      if (event.detail && event.detail.status === 'error') handleStickyAtcError();
      else handleStickyAtcSuccess();
    });

    if (window.jQuery_T4NT) {
      window.jQuery_T4NT(document.body).on('cart:updated', function(event, status) {
        if (status === 'error') handleStickyAtcError();
        else handleStickyAtcSuccess();
      });
    }

    function hasSelectedHulkProperties() {
      var properties = collectHulkProperties();
      return Object.keys(properties).some(function(name) {
        return properties[name];
      });
    }

    function isHulkMissingOptionsNotice(message) {
      return String(message || '').indexOf('Please select some product options before adding this product to your cart') !== -1;
    }

    function hideFalseHulkNotice() {
      var notice = document.getElementById('t4s-notices__wrapper');
      var message = notice && notice.querySelector('.t4s-notices__mess');
      if (!notice || !message || !isHulkMissingOptionsNotice(message.textContent)) return;
      if (!hasSelectedHulkProperties()) return;

      notice.classList.remove('is--show');
      document.documentElement.classList.remove('is--active-notices');
      if (window.jQuery_T4NT) window.jQuery_T4NT(document.body).trigger('hide.t4s.notices');
    }

    function patchThemeNotices() {
      if (!window.T4SThemeSP || typeof window.T4SThemeSP.Notices !== 'function' || window.T4SThemeSP.Notices._hulkNoticeGuard) return false;

      var originalNotices = window.T4SThemeSP.Notices;
      var guardedNotices = function(message, type) {
        if (isHulkMissingOptionsNotice(message) && hasSelectedHulkProperties()) {
          return;
        }
        return originalNotices.apply(this, arguments);
      };
      guardedNotices._hulkNoticeGuard = true;
      window.T4SThemeSP.Notices = guardedNotices;
      return true;
    }

    var noticePatchAttempts = 0;
    var noticePatchTimer = setInterval(function() {
      if (patchThemeNotices() || noticePatchAttempts > 80) clearInterval(noticePatchTimer);
      noticePatchAttempts += 1;
    }, 100);

    var noticesObserver = new MutationObserver(hideFalseHulkNotice);
    noticesObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    function updateTotalPrice() {
  var variantId = getCurrentVariantId();
  var variant = hulk_variants.find(function(v) { return v.id == variantId; });
  if (!variant) {
    clearPricePending();
    return;
  }
  
  var variantPrice = variant.price;
  var compareAtPrice = variant.compare_at_price; // может быть null

  var hulkTotal = getHulkOptionsTotal();
  var finalPrice = variantPrice + hulkTotal;
  var finalCompareAt = compareAtPrice ? compareAtPrice + hulkTotal : null;

  console.log('[Hulk Fix] Variant:', variantPrice/100, '| CompareAt:', compareAtPrice/100, '| Hulk:', hulkTotal/100, '| Final:', finalPrice/100);

  var formattedPrice = formatMoney(finalPrice);
  var formattedCompare = finalCompareAt ? formatMoney(finalCompareAt) : null;
  
  // Если есть compare-at и она больше цены — рендерим зачёркнутую + новую
  if (formattedCompare && finalCompareAt > finalPrice) {
    setPriceHtml($priceEl, '<del class="t4s-compare-price"><span class="money">' + formattedCompare + '</span></del> <ins class="t4s-product-price__sale"><span class="money">' + formattedPrice + '</span></ins>');
  } else {
    // Без скидки — просто цена. Заменяем HTML целиком, чтобы убрать старые nested .money от Hulk/Currency.
    setPriceHtml($priceEl, '<span class="money">' + formattedPrice + '</span>');
  }
  
  // Data атрибуты
  $priceEl.attr('data-product-price', finalPrice);
  $priceEl.attr('data-pr-price', finalPrice);
  
  // Sticky bar
  var $sticky = $('.t4s-sticky-atc__price').first();
  if ($sticky.length) {
    if (formattedCompare && finalCompareAt > finalPrice) {
      setPriceHtml($sticky, '<del>' + formattedCompare + '</del> <ins>' + formattedPrice + '</ins>');
    } else {
      setPriceHtml($sticky, formattedPrice);
    }
  }
  clearPricePending();
}

    // Перехватываем оригинальную функцию Hulk (отключаем её обновление цены)
    var originalHulkPriceUpdate = null;
    
    // Ищем и переопределяем функцию обновления цены Hulk
    if ($.fn.hulkUpdatePrice) {
      originalHulkPriceUpdate = $.fn.hulkUpdatePrice;
      $.fn.hulkUpdatePrice = function() {
        // Вызываем нашу функцию вместо оригинальной
        setTimeout(updateTotalPrice, 10);
        return this;
      };
    }

    // Слушаем изменение варианта
    $(document).on('change', 'select[name="id"], input[name="id"]', function() {
      setTimeout(updateTotalPrice, 100);
    });

    // Слушаем клики по T4S swatches
    $(document).on('click', '.t4s-swatch__item, [data-option-index], .t4s-pr-swatch', function() {
      setTimeout(updateTotalPrice, 200);
      setTimeout(updateTotalPrice, 500);
    });

    // Слушаем изменения Hulk опций
    $(document).on('click', '.hulk_po_radio', function() {
      setTimeout(updateTotalPrice, 50);
    });

    $(document).on('click', '.hulkapps_buton_option, .hulkapps_swatch_option', function() {
      syncHulkRadioLabel(this);
    });

    $(document).on('click', '.hulkapps_check_option', function() {
      setTimeout(updateTotalPrice, 100);
    });
    
    $(document).on('change', '.hulk_po_radiobutton, .hulk_po_checkbox, select.hulkapps_option_child', function() {
      setTimeout(updateTotalPrice, 50);
    });
    // Wrought Iron размеры
    $(document).on('input', '#wi-door-height, #wi-door-width', function() {
      setTimeout(updateTotalPrice, 50);
    });
    // Отключаем стандартное обновление цены Hulk через MutationObserver
    var isOurUpdate = false;
    var observer = new MutationObserver(function(mutations) {
      if (isOurUpdate) return;

      var variantId = getCurrentVariantId();
      var variant = hulk_variants.find(function(v) { return v.id == variantId; });
      if (!variant) return;

      var hulkTotal = getHulkOptionsTotal();
      var expectedCents = variant.price + hulkTotal;
      var expectedCompare = variant.compare_at_price ? variant.compare_at_price + hulkTotal : null;
      var onSale = expectedCompare && expectedCompare > expectedCents;

      // Displayed sale price (the <ins>/.money value).
      var currentText = $priceEl.find('ins .money, ins, .money').last().text() || $priceEl.text();
      var currentCents = moneyTextToCents(currentText);
      var saleWrong = currentCents !== expectedCents;

      // Displayed compare-at price (the <del> strikethrough value). Hulk/theme often
      // re-render <del> with the sale price, making the strikethrough equal the <ins>
      // value — that case passes the saleWrong check above, so it must be detected here.
      var $del = $priceEl.find('del .money, del').last();
      var delCents = $del.length ? moneyTextToCents($del.text()) : null;
      var compareWrong = onSale
        ? (delCents === null || delCents !== expectedCompare)
        : ($del.length > 0);

      if (saleWrong || compareWrong) {
        // Hulk/theme reset the displayed price — correct it back to the calculated value.
        console.log('[Hulk Fix] Detected price reset, correcting...');
        isOurUpdate = true;
        updateTotalPrice();
        setTimeout(function() { isOurUpdate = false; }, 100);
      }
    });
    
    observer.observe($priceEl[0], { childList: true, subtree: true, characterData: true });

    // Инициализация
    setTimeout(updateTotalPrice, 300);
    
  }, 100);
})();
